module.exports = __webpack_public_path__ + "static/media/resham1.147a08b4.jpg";